/// <reference types="./guards.d.mts" />
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $user from "../data/user.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Roles extends $CustomType {
  constructor(admin, content_curator, contributor, proposal_manager, super_admin) {
    super();
    this.admin = admin;
    this.content_curator = content_curator;
    this.contributor = contributor;
    this.proposal_manager = proposal_manager;
    this.super_admin = super_admin;
  }
}

function match_one(user_roles, needed) {
  let _pipe = $list.find(
    user_roles,
    (r) => {
      let _pipe = $list.find(needed, (needed) => { return r.name === needed; });
      return $result.is_ok(_pipe);
    },
  );
  return $result.is_ok(_pipe);
}

export const roles = /* @__PURE__ */ new Roles(
  "Admin",
  "Content Curator",
  "Contributor",
  "Proposal Manager",
  "Super Admin",
);

export function proposal_create(org_user) {
  let _pipe = org_user.roles;
  return match_one(
    _pipe,
    toList([roles.admin, roles.super_admin, roles.proposal_manager]),
  );
}

export function edit_proposal(org_user) {
  let _pipe = org_user.roles;
  return match_one(
    _pipe,
    toList([roles.admin, roles.super_admin, roles.proposal_manager]),
  );
}
